import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './Components/Context';
import { Provider } from 'react-redux';
import { persistor,store } from './redux/store';
import { PersistGate } from 'redux-persist/lib/integration/react';
import {  BrowserRouter, HashRouter, Router } from 'react-router-dom';
import AxiosErrorComp from './api/AxiosErrorComp';
import ScrollToTop from './Components/scrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <AppProvider>
    <BrowserRouter>
    <AxiosErrorComp/>
    <App />
    </BrowserRouter>
    </AppProvider>
      </PersistGate>
    </Provider>
    
);


reportWebVitals();
